import { EnglishStr } from "@/lib/EnglishStr";
import ErrorTemplate from "./ErrorTemplate";

export default function JointExpired() {
  
  return (
    <ErrorTemplate
      title="Sorry, your invitation code has expired."
      content={"This invitation code is either invalid or expired. Please call our Contact Centre at " + EnglishStr.ContactCentrePhone + " for assistance."}
    />
  );
}
